if (!customElements.get('product-bundle')) {
  customElements.define(
    'product-bundle',
    class ProductBundle extends HTMLElement {

      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';


        /* ==================================================
           PRODUCT DATA
        ================================================== */

        this.currentDataElement =
          this.querySelector(
            '[data-bundle-current-product]'
          );

        this.productsDataElement =
          this.querySelector(
            '[data-bundle-products]'
          );

        if (
          !this.currentDataElement ||
          !this.productsDataElement
        ) {
          return;
        }

        try {
          this.currentProduct =
            JSON.parse(
              this.currentDataElement.textContent
            );

          this.bundleProducts =
            JSON.parse(
              this.productsDataElement.textContent
            );
        } catch (error) {
          console.error(
            'Bundle product data could not be loaded.',
            error
          );

          return;
        }


        /* ==================================================
           SETTINGS
        ================================================== */

        this.enableBundleTiers =
          this.dataset.enableBundleTiers === 'true';

        this.currency =
          this.dataset.currency || 'AUD';

        this.legacyDiscount =
          Number(
            this.dataset.discountPercentage || 0
          );

        this.tierDiscounts = {
          2:
            Number(
              this.dataset.tier2Discount || 0
            ),

          3:
            Number(
              this.dataset.tier3Discount || 0
            ),

          4:
            Number(
              this.dataset.tier4Discount || 0
            ),

          5:
            Number(
              this.dataset.tier5Discount || 0
            )
        };

        this.enabledTiers =
          [2, 3, 4, 5].filter(
            size =>
              this.dataset[
                `tier${size}Enabled`
              ] === 'true'
          );

        if (
          this.enabledTiers.length === 0
        ) {
          this.enabledTiers = [2];
        }

        const requestedDefault =
          Number(
            this.dataset.defaultBundleSize || 2
          );

        if (
          this.enableBundleTiers &&
          this.enabledTiers.includes(
            requestedDefault
          )
        ) {
          this.activeTier =
            requestedDefault;
        } else if (
          this.enableBundleTiers
        ) {
          this.activeTier =
            this.enabledTiers[0];
        } else {
          this.activeTier = 2;
        }

        this.activePickerSlot = 2;


        /* ==================================================
           ITEM 02–05 SELECTION MEMORY
        ================================================== */

        this.selections =
          new Map();

        [2, 3, 4, 5].forEach(
          index => {
            this.selections.set(
              index,
              null
            );
          }
        );


        /* ==================================================
           CURRENT ITEM
        ================================================== */

        this.currentVariantSelect =
          this.querySelector(
            '[data-bundle-current-variant-select]'
          );

        this.currentImage =
          this.querySelector(
            '[data-bundle-current-image]'
          );

        this.currentPrice =
          this.querySelector(
            '[data-bundle-current-price]'
          );


        /* ==================================================
           PRICE / BUTTON
        ================================================== */

        this.footer =
          this.querySelector(
            '[data-bundle-footer]'
          );

        this.promoPrice =
          this.querySelector(
            '[data-bundle-promo-price]'
          );

        this.totalPrice =
          this.querySelector(
            '[data-bundle-total-price]'
          );

        this.saving =
          this.querySelector(
            '[data-bundle-saving]'
          );

        this.promoLabel =
          this.querySelector(
            '.product-bundle__promo-label'
          );

        this.totalLabel =
          this.querySelector(
            '.product-bundle__regular-row > span'
          );

        this.exactPromoLabel =
          this.promoLabel?.textContent.trim() ||
          'BUNDLE PRICE';

        this.exactTotalLabel =
          this.totalLabel?.textContent.trim() ||
          'TOTAL';

        if (
          this.saving &&
          !this.saving.dataset.bundleSavingLabel
        ) {
          this.saving.dataset.bundleSavingLabel =
            'SAVE';
        }

        this.addButton =
          this.querySelector(
            '[data-bundle-add]'
          );

        this.buttonText =
          this.querySelector(
            '[data-bundle-button-text]'
          );

        this.errorBox =
          this.querySelector(
            '[data-bundle-error]'
          );

        this.legacyTriggerText =
          this.querySelector(
            '[data-bundle-legacy-trigger-text]'
          );


        /* ==================================================
           PRODUCT PICKER
        ================================================== */

        this.picker =
          this.querySelector(
            '[data-bundle-picker]'
          );

        this.pickerHeading =
          this.querySelector(
            '[data-bundle-picker-heading]'
          );

        this.closePickerButtons =
          this.querySelectorAll(
            '[data-bundle-close-picker]'
          );

        this.pickerProducts =
          this.querySelectorAll(
            '[data-bundle-picker-product]'
          );

        /*
         * Placeholder used while the picker
         * is temporarily moved into <body>.
         */
        this.pickerPlaceholder = null;


        /* ==================================================
           BUNDLE TIERS
        ================================================== */

        this.tierButtons =
          this.querySelectorAll(
            '[data-bundle-tier]'
          );


        /* ==================================================
           ITEM 02–05 SLOT ELEMENTS
        ================================================== */

        this.slots =
          new Map();

        this.querySelectorAll(
          '[data-bundle-slot]'
        ).forEach(
          root => {
            const index =
              Number(
                root.dataset.slotIndex
              );

            const slot = {
              index,

              root,

              empty:
                root.querySelector(
                  '[data-bundle-slot-empty]'
                ),

              selected:
                root.querySelector(
                  '[data-bundle-slot-selected]'
                ),

              image:
                root.querySelector(
                  '[data-bundle-slot-image]'
                ),

              title:
                root.querySelector(
                  '[data-bundle-slot-title]'
                ),

              price:
                root.querySelector(
                  '[data-bundle-slot-price]'
                ),

              variantSelect:
                root.querySelector(
                  '[data-bundle-slot-variant]'
                )
            };

            this.slots.set(
              index,
              slot
            );

            slot.variantSelect
              ?.addEventListener(
                'change',
                () => {
                  this.slotVariantChanged(
                    index
                  );
                }
              );
          }
        );


        /* ==================================================
           MAIN SHOPIFY PRODUCT FORM
        ================================================== */

        this.form =
          document.getElementById(
            this.dataset.productFormId
          );

        this.currentVariantInput =
          this.form
            ?
              this.form.querySelector(
                '[name="id"]'
              )
            :
              null;


        /* ==================================================
           MAIN THEME VARIANT PICKER
        ================================================== */

        this.variantPicker =
          document.getElementById(
            `variant-selects-${this.dataset.sectionId}`
          )
          ||
          document.querySelector(
            `variant-selects[data-product-id="${this.currentProduct.id}"]`
          );


        /* ==================================================
           PRODUCT SCOPE
        ================================================== */

        this.productScope =
          this.variantPicker
            ?.closest(
              '.product-information'
            )
          ||
          this.closest(
            '.product-information'
          )
          ||
          this.closest(
            '.product__info-container'
          )
          ||
          this.closest(
            '.product'
          )
          ||
          this.parentElement;


        /* ==================================================
           MONEY
        ================================================== */

        this.moneyFormatter =
          new Intl.NumberFormat(
            document.documentElement.lang ||
            'en-AU',
            {
              style: 'currency',
              currency: this.currency
            }
          );


        /* ==================================================
           ITEM 01 BUNDLE SIZE CHANGE
        ================================================== */

        this.currentVariantSelect
          ?.addEventListener(
            'change',
            () => {
              this.bundleVariantChanged();
            }
          );


        /* ==================================================
           TIER BUTTONS
        ================================================== */

        this.tierButtons.forEach(
          button => {
            button.addEventListener(
              'click',
              () => {
                this.setActiveTier(
                  Number(
                    button.dataset.bundleTier
                  )
                );
              }
            );
          }
        );


        /* ==================================================
           OPEN PICKER BUTTONS
        ================================================== */

        this.querySelectorAll(
          '[data-bundle-open-picker]'
        ).forEach(
          button => {
            button.addEventListener(
              'click',
              () => {
                this.openPicker(
                  Number(
                    button.dataset.slotIndex || 2
                  )
                );
              }
            );
          }
        );


        /* ==================================================
           CLOSE PICKER
        ================================================== */

        this.closePickerButtons.forEach(
          button => {
            button.addEventListener(
              'click',
              () => {
                this.closePicker();
              }
            );
          }
        );


        /* ==================================================
           ESC CLOSE
        ================================================== */

        this.escapeHandler =
          event => {
            if (
              event.key === 'Escape' &&
              this.picker &&
              !this.picker.hidden
            ) {
              this.closePicker();
            }
          };

        document.addEventListener(
          'keydown',
          this.escapeHandler
        );


        /* ==================================================
           PICKER PRODUCTS
        ================================================== */

        this.pickerProducts.forEach(
          productRow => {
            const variantSelect =
              productRow.querySelector(
                '[data-picker-variant]'
              );

            const chooseButton =
              productRow.querySelector(
                '[data-picker-choose]'
              );

            variantSelect
              ?.addEventListener(
                'change',
                () => {
                  this.updatePickerProduct(
                    productRow
                  );
                }
              );

            chooseButton
              ?.addEventListener(
                'click',
                () => {
                  this.choosePickerProduct(
                    productRow
                  );
                }
              );

            this.updatePickerProduct(
              productRow
            );
          }
        );


        /* ==================================================
           ADD BUNDLE
        ================================================== */

        this.addButton
          ?.addEventListener(
            'click',
            () => {
              this.addBundle();
            }
          );


        /* ==================================================
           NORMAL VARIANT PICKER -> BUNDLE ITEM 01
        ================================================== */

        this.mainChangeHandler =
          event => {

            if (
              event.target.closest(
                '.product-bundle-picker'
              )
            ) {
              return;
            }

            if (
              event.target.closest(
                'product-bundle'
              )
            ) {
              return;
            }

            if (
              this.variantPicker &&
              !this.variantPicker.contains(
                event.target
              )
            ) {
              return;
            }

            window.setTimeout(
              () => {
                this.syncBundleFromMain();
              },
              0
            );

            window.setTimeout(
              () => {
                this.syncBundleFromMain();
              },
              80
            );

            window.setTimeout(
              () => {
                this.syncBundleFromMain();
              },
              180
            );
          };

        document.addEventListener(
          'change',
          this.mainChangeHandler,
          true
        );


        /* ==================================================
           WATCH MAIN HIDDEN VARIANT
        ================================================== */

        this.lastMainVariantId =
          this.currentVariantInput?.value ||
          '';

        this.syncInterval =
          window.setInterval(
            () => {
              const variantId =
                this.currentVariantInput?.value ||
                '';

              if (
                variantId &&
                variantId !==
                  this.lastMainVariantId
              ) {
                this.lastMainVariantId =
                  variantId;

                this.syncBundleFromMain();
              }
            },
            200
          );


        /* ==================================================
           INITIAL STATE
        ================================================== */

        this.syncBundleFromMain();

        this.setActiveTier(
          this.activeTier,
          true
        );
      }


      /* ====================================================
         DISCONNECT
      ==================================================== */

      disconnectedCallback() {
        if (
          this.mainChangeHandler
        ) {
          document.removeEventListener(
            'change',
            this.mainChangeHandler,
            true
          );
        }

        if (
          this.escapeHandler
        ) {
          document.removeEventListener(
            'keydown',
            this.escapeHandler
          );
        }
                if (
          this.syncInterval
        ) {
          window.clearInterval(
            this.syncInterval
          );
        }

        if (
          this.picker &&
          this.picker.parentNode ===
            document.body
        ) {
          this.picker.remove();
        }

        if (
          this.pickerPlaceholder
        ) {
          this.pickerPlaceholder.remove();
          this.pickerPlaceholder = null;
        }

        document.documentElement
          .classList.remove(
            'bundle-picker-open'
          );

        document.body
          .classList.remove(
            'bundle-picker-open'
          );
      }


      /* ====================================================
         MONEY
      ==================================================== */

      formatMoney(cents) {
        return this.moneyFormatter.format(
          (Number(cents) || 0) / 100
        );
      }


      /* ====================================================
         CURRENT VARIANT
      ==================================================== */

      getCurrentVariant() {
        const variantId =
          Number(
            this.currentVariantInput?.value
            ||
            this.currentVariantSelect?.value
            ||
            0
          );

        return (
          this.currentProduct.variants.find(
            variant =>
              Number(variant.id) ===
              variantId
          )
          ||
          this.currentProduct.variants.find(
            variant =>
              variant.available
          )
          ||
          this.currentProduct.variants[0]
        );
      }


      /* ====================================================
         MAIN PAGE -> BUNDLE ITEM 01
      ==================================================== */

      syncBundleFromMain() {
        if (
          !this.currentVariantInput
        ) {
          return;
        }

        const variantId =
          Number(
            this.currentVariantInput.value
          );

        const variant =
          this.currentProduct.variants.find(
            item =>
              Number(item.id) ===
              variantId
          );

        if (
          !variant
        ) {
          return;
        }

        this.lastMainVariantId =
          String(
            variant.id
          );

        if (
          this.currentVariantSelect &&
          this.currentVariantSelect.value !==
            String(variant.id)
        ) {
          this.currentVariantSelect.value =
            String(
              variant.id
            );
        }

        this.updateCurrentVariantDisplay(
          variant
        );
      }


      /* ====================================================
         BUNDLE ITEM 01 -> MAIN PRODUCT VARIANT
      ==================================================== */

      bundleVariantChanged() {
        const variantId =
          Number(
            this.currentVariantSelect?.value
          );

        const variant =
          this.currentProduct.variants.find(
            item =>
              Number(item.id) ===
              variantId
          );

        if (
          !variant
        ) {
          return;
        }

        this.syncMainOptionControls(
          variant
        );

        this.updateCurrentVariantDisplay(
          variant
        );

        window.setTimeout(
          () => {
            this.ensureMainVariantId(
              variant
            );
          },
          80
        );

        window.setTimeout(
          () => {
            this.ensureMainVariantId(
              variant
            );

            this.syncBundleFromMain();
          },
          180
        );

        window.setTimeout(
          () => {
            this.ensureMainVariantId(
              variant
            );

            this.syncBundleFromMain();
          },
          350
        );
      }


      /* ====================================================
         UPDATE MAIN VISIBLE OPTION BUTTONS
      ==================================================== */

      syncMainOptionControls(variant) {
        if (
          !variant ||
          !Array.isArray(
            variant.options
          )
        ) {
          return;
        }

        this.variantPicker =
          this.variantPicker
          ||
          document.getElementById(
            `variant-selects-${this.dataset.sectionId}`
          )
          ||
          document.querySelector(
            `variant-selects[data-product-id="${this.currentProduct.id}"]`
          );

        if (
          !this.variantPicker
        ) {
          return;
        }

        let groups =
          Array.from(
            this.variantPicker.querySelectorAll(
              '.variations > fieldset'
            )
          );

        if (
          groups.length === 0
        ) {
          groups =
            Array.from(
              this.variantPicker.querySelectorAll(
                'fieldset'
              )
            );
        }

        if (
          groups.length === 0
        ) {
          groups =
            Array.from(
              this.variantPicker.querySelectorAll(
                '.product-form__input'
              )
            );
        }

        variant.options.forEach(
          (wantedValue, index) => {
            const group =
              groups[index];

            if (
              !group
            ) {
              return;
            }

            const wanted =
              String(
                wantedValue
              ).trim();


            /* SELECT */

            const select =
              group.querySelector(
                'select'
              );

            if (
              select
            ) {
              if (
                select.value !==
                wanted
              ) {
                select.value =
                  wanted;

                select.dispatchEvent(
                  new Event(
                    'input',
                    {
                      bubbles: true
                    }
                  )
                );

                select.dispatchEvent(
                  new Event(
                    'change',
                    {
                      bubbles: true
                    }
                  )
                );
              }

              return;
            }


            /* RADIO */

            const inputs =
              Array.from(
                group.querySelectorAll(
                  'input'
                )
              );

            const matchingInput =
              inputs.find(
                input =>
                  String(
                    input.value
                  ).trim() ===
                  wanted
              );

            if (
              matchingInput
            ) {
              if (
                !matchingInput.checked
              ) {
                matchingInput.click();
              } else {
                matchingInput.dispatchEvent(
                  new Event(
                    'change',
                    {
                      bubbles: true
                    }
                  )
                );
              }

              return;
            }


            /* LABEL FALLBACK */

            const labels =
              Array.from(
                group.querySelectorAll(
                  'label'
                )
              );

            const matchingLabel =
              labels.find(
                label => {
                  const text =
                    String(
                      label.textContent || ''
                    )
                      .replace(/\s+/g, ' ')
                      .trim();

                  return (
                    text === wanted ||
                    text.startsWith(
                      `${wanted} `
                    )
                  );
                }
              );

            if (
              matchingLabel
            ) {
              matchingLabel.click();
            }
          }
        );
      }


      /* ====================================================
         ENSURE MAIN VARIANT ID
      ==================================================== */

      ensureMainVariantId(variant) {
        if (
          !variant
        ) {
          return;
        }

        if (
          this.currentVariantInput &&
          Number(
            this.currentVariantInput.value
          ) !==
          Number(
            variant.id
          )
        ) {
          this.currentVariantInput.value =
            String(
              variant.id
            );

          this.currentVariantInput.dispatchEvent(
            new Event(
              'input',
              {
                bubbles: true
              }
            )
          );

          this.currentVariantInput.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );
        }

        const selectedVariant =
          document.getElementById(
            `SelectedVariant-${this.dataset.sectionId}`
          );

        if (
          selectedVariant
        ) {
          selectedVariant.dataset.variantId =
            String(
              variant.id
            );

          selectedVariant.dataset.available =
            String(
              variant.available
            );
        }

        this.lastMainVariantId =
          String(
            variant.id
          );
      }


      /* ====================================================
         CURRENT ITEM DISPLAY
      ==================================================== */

      updateCurrentVariantDisplay(variant) {
        if (!variant) return;

        if (
          this.currentPrice
        ) {
          this.currentPrice.textContent =
            this.formatMoney(
              variant.price
            );
        }

        if (
          this.currentImage &&
          variant.image
        ) {
          this.currentImage.src =
            variant.image;
        }

        this.updatePrices();

        this.updateButtonState();
      }


      /* ====================================================
         ACTIVE BUNDLE SIZE
      ==================================================== */

      setActiveTier(
        requestedSize,
        initial = false
      ) {
        let size =
          Number(
            requestedSize || 2
          );

        if (
          this.enableBundleTiers &&
          !this.enabledTiers.includes(
            size
          )
        ) {
          size =
            this.enabledTiers[0];
        }

        if (
          !this.enableBundleTiers
        ) {
          size = 2;
        }

        this.activeTier =
          size;


        this.tierButtons.forEach(
          button => {
            const isActive =
              Number(
                button.dataset.bundleTier
              ) ===
              this.activeTier;

            button.classList.toggle(
              'is-active',
              isActive
            );

            button.setAttribute(
              'aria-pressed',
              isActive
                ?
                  'true'
                :
                  'false'
            );
          }
        );


        this.slots.forEach(
          (slot, index) => {
            if (
              !this.enableBundleTiers
            ) {
              slot.root.hidden =
                index !== 2;

              if (
                index === 2
              ) {
                this.renderSlot(
                  index
                );
              }

              return;
            }

            slot.root.hidden =
              index >
              this.activeTier;

            if (
              !slot.root.hidden
            ) {
              this.renderSlot(
                index
              );
            }
          }
        );

        this.updatePrices();

        this.updateButtonState();

        if (
          !initial
        ) {
          this.showError('');
        }
      }


      /* ====================================================
         ACTIVE DISCOUNT
      ==================================================== */

      getActiveDiscount() {
        if (
          !this.enableBundleTiers
        ) {
          return Number(
            this.legacyDiscount || 0
          );
        }

        return Number(
          this.tierDiscounts[
            this.activeTier
          ] || 0
        );
      }


      /* ====================================================
         REQUIRED ITEM INDEXES
      ==================================================== */

      getRequiredSlotIndexes() {
        const indexes = [];

        for (
          let index = 2;
          index <= this.activeTier;
          index += 1
        ) {
          indexes.push(
            index
          );
        }

        return indexes;
      }


      /* ====================================================
         PRODUCT LOOKUP
      ==================================================== */

      getProductById(productId) {
        return (
          this.bundleProducts.find(
            product =>
              Number(product.id) ===
              Number(productId)
          )
          ||
          null
        );
      }


      /* ====================================================
         SLOT SELECTION
      ==================================================== */

      getSelection(index) {
        return (
          this.selections.get(
            Number(index)
          )
          ||
          null
        );
      }


      /* ====================================================
         SELECTED SLOT VARIANT
      ==================================================== */

      getSelectedVariantForSlot(index) {
        const selection =
          this.getSelection(
            index
          );

        if (
          !selection
        ) {
          return null;
        }

        const product =
          this.getProductById(
            selection.productId
          );

        if (
          !product
        ) {
          return null;
        }

        return (
          product.variants.find(
            variant =>
              Number(variant.id) ===
              Number(
                selection.variantId
              )
          )
          ||
          product.variants.find(
            variant =>
              variant.available
          )
          ||
          null
        );
      }


      /* ====================================================
         RENDER SLOT
      ==================================================== */

      renderSlot(index) {
        const slot =
          this.slots.get(
            Number(index)
          );

        if (
          !slot
        ) {
          return;
        }

        const selection =
          this.getSelection(
            index
          );

        if (
          this.enableBundleTiers
        ) {
          if (
            slot.empty
          ) {
            slot.empty.hidden =
              Boolean(
                selection
              );
          }

          if (
            slot.selected
          ) {
            slot.selected.hidden =
              !selection;
          }
        } else {
          if (
            slot.selected
          ) {
            slot.selected.hidden =
              !selection;
          }

          if (
            this.legacyTriggerText
          ) {
            this.legacyTriggerText.textContent =
              selection
                ?
                  'CHANGE SECOND ITEM'
                :
                  'CHOOSE SECOND ITEM';
          }
        }

        if (
          !selection
        ) {
          return;
        }

        const product =
          this.getProductById(
            selection.productId
          );

        const variant =
          this.getSelectedVariantForSlot(
            index
          );

        if (
          !product ||
          !variant
        ) {
          return;
        }

        if (
          slot.title
        ) {
          slot.title.textContent =
            product.title;
        }

        if (
          slot.price
        ) {
          slot.price.textContent =
            this.formatMoney(
              variant.price
            );
        }

        if (
          slot.image
        ) {
          if (
            variant.image
          ) {
            slot.image.src =
              variant.image;

            slot.image.alt =
              product.title;

            slot.image.hidden =
              false;
          } else {
            slot.image.hidden =
              true;
          }
        }
      }


      /* ====================================================
         BUILD SELECTED ITEM SIZE SELECT
      ==================================================== */

      populateSlotVariantSelect(
        index,
        product,
        preferredVariantId
      ) {
        const slot =
          this.slots.get(
            Number(index)
          );

        if (
          !slot?.variantSelect ||
          !product
        ) {
          return;
        }

        slot.variantSelect.innerHTML =
          '';

        product.variants.forEach(
          variant => {
            const option =
              document.createElement(
                'option'
              );

            option.value =
              String(
                variant.id
              );

            option.textContent =
              variant.available
                ?
                  variant.title
                :
                  `${variant.title} — Sold out`;

            option.disabled =
              !variant.available;

            option.selected =
              Number(
                variant.id
              ) ===
              Number(
                preferredVariantId
              );

            slot.variantSelect.appendChild(
              option
            );
          }
        );

        slot.variantSelect.hidden =
          (
            product.variants.length === 1
            &&
            product.variants[0].title ===
              'Default Title'
          );
      }


      /* ====================================================
         SLOT SIZE CHANGE
      ==================================================== */

      slotVariantChanged(index) {
        const slot =
          this.slots.get(
            Number(index)
          );

        const selection =
          this.getSelection(
            index
          );

        if (
          !slot?.variantSelect ||
          !selection
        ) {
          return;
        }

        const product =
          this.getProductById(
            selection.productId
          );

        if (
          !product
        ) {
          return;
        }

        const variantId =
          Number(
            slot.variantSelect.value
          );

        const variant =
          product.variants.find(
            item =>
              Number(item.id) ===
              variantId
          );

        if (
          !variant
        ) {
          return;
        }

        this.selections.set(
          Number(index),
          {
            productId:
              Number(
                product.id
              ),

            variantId:
              Number(
                variant.id
              )
          }
        );

        this.renderSlot(
          index
        );

        this.syncPickerRowToSelection(
          index
        );

        this.updatePrices();

        this.updateButtonState();
      }
            /* ====================================================
         MOVE PICKER TO BODY
      ==================================================== */

      portalPickerToBody() {
        if (
          !this.picker ||
          this.picker.parentNode ===
            document.body
        ) {
          return;
        }

        this.pickerPlaceholder =
          document.createComment(
            'product-bundle-picker-placeholder'
          );

        this.picker.parentNode.insertBefore(
          this.pickerPlaceholder,
          this.picker
        );

        document.body.appendChild(
          this.picker
        );
      }


      /* ====================================================
         MOVE PICKER BACK
      ==================================================== */

      restorePicker() {
        if (
          !this.picker ||
          !this.pickerPlaceholder ||
          !this.pickerPlaceholder.parentNode
        ) {
          return;
        }

        this.pickerPlaceholder.parentNode.insertBefore(
          this.picker,
          this.pickerPlaceholder
        );

        this.pickerPlaceholder.remove();

        this.pickerPlaceholder =
          null;
      }


      /* ====================================================
         OPEN PICKER
      ==================================================== */

      openPicker(slotIndex) {
        if (
          !this.picker
        ) {
          return;
        }

        this.activePickerSlot =
          Math.min(
            5,
            Math.max(
              2,
              Number(
                slotIndex || 2
              )
            )
          );

        if (
          this.pickerHeading
        ) {
          this.pickerHeading.textContent =
            this.enableBundleTiers
              ?
                `CHOOSE ITEM 0${this.activePickerSlot}`
              :
                'CHOOSE PRODUCT';
        }

        this.syncPickerRowToSelection(
          this.activePickerSlot
        );

        this.portalPickerToBody();

        this.picker.hidden =
          false;

        this.picker.setAttribute(
          'aria-hidden',
          'false'
        );

        document.documentElement
          .classList.add(
            'bundle-picker-open'
          );

        document.body
          .classList.add(
            'bundle-picker-open'
          );
      }


      /* ====================================================
         CLOSE PICKER
      ==================================================== */

      closePicker() {
        if (
          !this.picker
        ) {
          return;
        }

        this.picker.hidden =
          true;

        this.picker.setAttribute(
          'aria-hidden',
          'true'
        );

        document.documentElement
          .classList.remove(
            'bundle-picker-open'
          );

        document.body
          .classList.remove(
            'bundle-picker-open'
          );

        this.restorePicker();
      }


      /* ====================================================
         SYNC PICKER TO SLOT
      ==================================================== */

      syncPickerRowToSelection(index) {
        const selection =
          this.getSelection(
            index
          );

        if (
          !selection
        ) {
          return;
        }

        const selectedRow =
          Array.from(
            this.pickerProducts
          ).find(
            row =>
              Number(
                row.dataset.productId
              ) ===
              Number(
                selection.productId
              )
          );

        if (
          !selectedRow
        ) {
          return;
        }

        const select =
          selectedRow.querySelector(
            '[data-picker-variant]'
          );

        if (
          select &&
          selection.variantId
        ) {
          select.value =
            String(
              selection.variantId
            );

          this.updatePickerProduct(
            selectedRow
          );
        }
      }


      /* ====================================================
         UPDATE PICKER CARD
      ==================================================== */

      updatePickerProduct(productRow) {
        const select =
          productRow.querySelector(
            '[data-picker-variant]'
          );

        if (
          !select
        ) {
          return;
        }

        const option =
          select.options[
            select.selectedIndex
          ];

        if (
          !option
        ) {
          return;
        }

        const price =
          productRow.querySelector(
            '[data-picker-price]'
          );

        const compare =
          productRow.querySelector(
            '[data-picker-compare]'
          );

        const image =
          productRow.querySelector(
            '[data-picker-image]'
          );

        const choose =
          productRow.querySelector(
            '[data-picker-choose]'
          );


        if (
          price
        ) {
          price.textContent =
            option.dataset.priceText
            ||
            this.formatMoney(
              option.dataset.price
            );
        }


        const currentPrice =
          Number(
            option.dataset.price || 0
          );

        const comparePrice =
          Number(
            option.dataset.comparePrice || 0
          );

        if (
          compare
        ) {
          if (
            comparePrice >
            currentPrice
          ) {
            compare.textContent =
              option.dataset.compareText
              ||
              this.formatMoney(
                comparePrice
              );

            compare.hidden =
              false;
          } else {
            compare.hidden =
              true;

            compare.textContent =
              '';
          }
        }


        if (
          image &&
          option.dataset.image
        ) {
          image.src =
            option.dataset.image;
        }


        if (
          choose
        ) {
          choose.disabled =
            option.disabled;
        }
      }


      /* ====================================================
         CHOOSE PRODUCT
      ==================================================== */

      choosePickerProduct(productRow) {
        const productId =
          Number(
            productRow.dataset.productId
          );

        const pickerVariantSelect =
          productRow.querySelector(
            '[data-picker-variant]'
          );

        if (
          !pickerVariantSelect
        ) {
          return;
        }

        const variantId =
          Number(
            pickerVariantSelect.value
          );

        const product =
          this.getProductById(
            productId
          );

        if (
          !product
        ) {
          return;
        }

        const variant =
          product.variants.find(
            item =>
              Number(item.id) ===
              variantId
          );

        if (
          !variant ||
          !variant.available
        ) {
          return;
        }

        const index =
          this.activePickerSlot;

        this.selections.set(
          index,
          {
            productId:
              Number(
                product.id
              ),

            variantId:
              Number(
                variant.id
              )
          }
        );

        this.populateSlotVariantSelect(
          index,
          product,
          variant.id
        );

        this.renderSlot(
          index
        );

        this.updatePrices();

        this.updateButtonState();

        this.closePicker();
      }


      /* ====================================================
         AVAILABLE BUNDLE VARIANT PRICES
      ==================================================== */

      getAvailableBundleVariantPrices() {
        const prices = [];

        this.bundleProducts.forEach(
          product => {
            product.variants.forEach(
              variant => {
                if (
                  variant.available &&
                  Number.isFinite(
                    Number(variant.price)
                  )
                ) {
                  prices.push(
                    Number(variant.price)
                  );
                }
              }
            );
          }
        );

        return prices;
      }


      /* ====================================================
         CHEAPEST AVAILABLE BUNDLE PRICE
      ==================================================== */

      getCheapestAvailableBundlePrice() {
        const prices =
          this.getAvailableBundleVariantPrices();

        if (
          prices.length === 0
        ) {
          return null;
        }

        return Math.min(
          ...prices
        );
      }


      /* ====================================================
         CHECK IF ALL BUNDLE PRICES ARE IDENTICAL

         If every eligible available variant is the
         same price, the preview is exact even before
         the remaining products are selected.
      ==================================================== */

      areAllEligibleBundleVariantsSamePrice() {
        const prices =
          this.getAvailableBundleVariantPrices();

        if (
          prices.length === 0
        ) {
          return false;
        }

        const firstPrice =
          prices[0];

        return prices.every(
          price =>
            Number(price) ===
            Number(firstPrice)
        );
      }


      /* ====================================================
         BUILD PRICE SUMMARY

         CURRENT ITEM:
         actual selected Item 01 price.

         SELECTED ADDITIONAL ITEMS:
         actual selected variant prices.

         EMPTY ADDITIONAL ITEMS:
         cheapest available bundle variant price.
      ==================================================== */

      getBundlePriceSummary() {
        const currentVariant =
          this.getCurrentVariant();

        if (
          !currentVariant?.available
        ) {
          return null;
        }

        let regularTotal =
          Number(
            currentVariant.price || 0
          );

        let missingCount = 0;

        this
          .getRequiredSlotIndexes()
          .forEach(
            index => {
              const variant =
                this.getSelectedVariantForSlot(
                  index
                );

              if (
                variant?.available
              ) {
                regularTotal +=
                  Number(
                    variant.price || 0
                  );
              } else {
                missingCount += 1;
              }
            }
          );


        /* ===============================================
           FILL EMPTY SLOTS WITH LOWEST AVAILABLE PRICE
        =============================================== */

        if (
          missingCount > 0
        ) {
          const cheapestPrice =
            this.getCheapestAvailableBundlePrice();

          if (
            cheapestPrice === null
          ) {
            return null;
          }

          regularTotal +=
            Number(
              cheapestPrice
            ) *
            missingCount;
        }


        /* ===============================================
           DISCOUNT
        =============================================== */

        const discount =
          this.getActiveDiscount();

        const savingAmount =
          Math.round(
            regularTotal *
            (
              discount / 100
            )
          );

        const bundlePrice =
          regularTotal -
          savingAmount;


        /* ===============================================
           DETERMINE WHETHER "FROM" IS REQUIRED
        =============================================== */

        const allAdditionalPricesSame =
          this.areAllEligibleBundleVariantsSamePrice();

        const isEstimate =
          missingCount > 0 &&
          !allAdditionalPricesSame;


        return {
          regularTotal,
          bundlePrice,
          savingAmount,
          discount,
          missingCount,
          isEstimate
        };
      }


      /* ====================================================
         UPDATE PRICE LABELS

         ESTIMATE:
         BUNDLE FROM
         REGULAR FROM
         SAVE FROM

         EXACT:
         BUNDLE PRICE
         TOTAL
         SAVE
      ==================================================== */

      updatePriceLabels(isEstimate) {
        if (
          this.promoLabel
        ) {
          this.promoLabel.textContent =
            isEstimate
              ?
                'BUNDLE FROM'
              :
                this.exactPromoLabel;
        }

        if (
          this.totalLabel
        ) {
          this.totalLabel.textContent =
            isEstimate
              ?
                'REGULAR FROM'
              :
                this.exactTotalLabel;
        }

        if (
          this.saving
        ) {
          this.saving.dataset.bundleSavingLabel =
            isEstimate
              ?
                'SAVE FROM'
              :
                'SAVE';
        }
      }


      /* ====================================================
         MISSING COUNT
      ==================================================== */

      getMissingCount() {
        return this
          .getRequiredSlotIndexes()
          .filter(
            index => {
              const variant =
                this.getSelectedVariantForSlot(
                  index
                );

              return (
                !variant ||
                !variant.available
              );
            }
          )
          .length;
      }


      /* ====================================================
         COMPLETE?
      ==================================================== */

      isComplete() {
        const currentVariant =
          this.getCurrentVariant();

        return (
          Boolean(
            currentVariant?.available
          )
          &&
          this.getMissingCount() ===
            0
        );
      }


      /* ====================================================
         PRICE

         This now stays visible even before the
         additional bundle products are selected.
      ==================================================== */

      updatePrices() {
        if (
          !this.footer
        ) {
          return;
        }

        const summary =
          this.getBundlePriceSummary();

        if (
          !summary
        ) {
          this.footer.hidden =
            true;

          return;
        }

        this.updatePriceLabels(
          summary.isEstimate
        );

        if (
          this.promoPrice
        ) {
          this.promoPrice.textContent =
            this.formatMoney(
              summary.bundlePrice
            );
        }

        if (
          this.totalPrice
        ) {
          this.totalPrice.textContent =
            this.formatMoney(
              summary.regularTotal
            );
        }

        if (
          this.saving
        ) {
          if (
            summary.savingAmount > 0
          ) {
            this.saving.textContent =
              this.formatMoney(
                summary.savingAmount
              );

            this.saving.hidden =
              false;
          } else {
            this.saving.hidden =
              true;
          }
        }

        this.footer.hidden =
          false;
      }
            /* ====================================================
         BUTTON
      ==================================================== */

      updateButtonState() {
        if (
          !this.addButton
        ) {
          return;
        }

        const currentVariant =
          this.getCurrentVariant();

        const missingCount =
          this.getMissingCount();

        const complete =
          Boolean(
            currentVariant?.available
          )
          &&
          missingCount === 0;


        /* ORIGINAL 2 ITEM MODE */

        if (
          !this.enableBundleTiers
        ) {
          this.addButton.hidden =
            !complete;

          this.addButton.disabled =
            !complete;

          if (
            complete &&
            this.buttonText
          ) {
            this.buttonText.textContent =
              this.dataset.addLabel
              ||
              'ADD BUNDLE';
          }

          return;
        }


        /* MULTI BUNDLE MODE */

        this.addButton.hidden =
          false;

        if (
          !currentVariant?.available
        ) {
          this.addButton.disabled =
            true;

          if (
            this.buttonText
          ) {
            this.buttonText.textContent =
              'CURRENT ITEM UNAVAILABLE';
          }

          return;
        }

        if (
          missingCount > 0
        ) {
          this.addButton.disabled =
            true;

          if (
            this.buttonText
          ) {
            this.buttonText.textContent =
              `CHOOSE ${missingCount} MORE ITEM${missingCount === 1 ? '' : 'S'}`;
          }

          return;
        }

        this.addButton.disabled =
          false;

        if (
          this.buttonText
        ) {
          this.buttonText.textContent =
            this.dataset.addLabel
            ||
            'ADD BUNDLE';
        }
      }


      /* ====================================================
         ERROR
      ==================================================== */

      showError(message) {
        if (
          !this.errorBox
        ) {
          return;
        }

        this.errorBox.textContent =
          message || '';

        this.errorBox.toggleAttribute(
          'hidden',
          !message
        );
      }


      /* ====================================================
         LOADING
      ==================================================== */

      setLoading(loading) {
        if (
          !this.addButton
        ) {
          return;
        }

        this.addButton.classList.toggle(
          'loading',
          loading
        );

        if (
          loading
        ) {
          this.addButton.disabled =
            true;

          if (
            this.buttonText
          ) {
            this.buttonText.textContent =
              this.dataset.addingLabel
              ||
              'ADDING...';
          }
        } else {
          this.updateButtonState();
        }
      }


      /* ====================================================
         ADD BUNDLE
      ==================================================== */

      async addBundle() {
        if (
          !this.isComplete()
        ) {
          this.updateButtonState();

          return;
        }

        const currentVariant =
          this.getCurrentVariant();

        const requiredIndexes =
          this.getRequiredSlotIndexes();

        const bundleKey =
          `${this.currentProduct.id}-${Date.now()}`;

        const items = [
          {
            id:
              currentVariant.id,

            quantity:
              1,

            properties: {
              '_Bundle':
                bundleKey,

              '_Bundle item':
                '1',

              '_Bundle size':
                String(
                  this.activeTier
                )
            }
          }
        ];

        requiredIndexes.forEach(
          index => {
            const variant =
              this.getSelectedVariantForSlot(
                index
              );

            items.push(
              {
                id:
                  variant.id,

                quantity:
                  1,

                properties: {
                  '_Bundle':
                    bundleKey,

                  '_Bundle item':
                    String(
                      index
                    ),

                  '_Bundle size':
                    String(
                      this.activeTier
                    )
                }
              }
            );
          }
        );

        this.showError('');

        this.setLoading(
          true
        );

        const payload = {
          items,

          sections: [
            'cart-drawer',
            'cart-bubble'
          ],

          sections_url:
            window.location.pathname
        };

        try {
          const root =
            window.Shopify?.routes?.root
            ||
            '/';

          const response =
            await fetch(
              `${root}cart/add.js`,
              {
                method:
                  'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json',

                  'X-Requested-With':
                    'XMLHttpRequest'
                },

                body:
                  JSON.stringify(
                    payload
                  )
              }
            );

          const data =
            await response.json();

          if (
            !response.ok ||
            data.status
          ) {
            throw new Error(
              data.description
              ||
              data.message
              ||
              'Unable to add this bundle to cart.'
            );
          }

          this.renderCartSections(
            data.sections || {}
          );

          if (
            typeof dispatchCustomEvent ===
            'function'
          ) {
            dispatchCustomEvent(
              'cart:item-added',
              {
                product:
                  data.items
                    ?
                      data.items[0]
                    :
                      data
              }
            );
          }

          const cartDrawer =
            document.getElementById(
              'Cart-Drawer'
            );

          if (
            cartDrawer &&
            typeof OverlayManager !==
              'undefined'
          ) {
            OverlayManager.open(
              cartDrawer
            );

            if (
              typeof dispatchCustomEvent ===
              'function'
            ) {
              dispatchCustomEvent(
                'cart-drawer:open'
              );
            }
          }

          this.setLoading(
            false
          );

          if (
            this.buttonText
          ) {
            this.buttonText.textContent =
              this.dataset.addedLabel
              ||
              'ADDED';
          }

          window.setTimeout(
            () => {
              this.updateButtonState();
            },
            1000
          );

        } catch (error) {
          this.setLoading(
            false
          );

          this.showError(
            error.message
            ||
            'Unable to add this bundle to cart.'
          );

          this.updateButtonState();
        }
      }


      /* ====================================================
         CART DRAWER REFRESH
      ==================================================== */

      renderCartSections(sections) {
        const mappings = [
          {
            id:
              'Cart-Drawer',

            key:
              'cart-drawer',

            selector:
              '.cart-drawer'
          },

          {
            id:
              'cart-drawer-toggle',

            key:
              'cart-bubble',

            selector:
              '.thb-item-count'
          }
        ];

        mappings.forEach(
          mapping => {
            const html =
              sections[
                mapping.key
              ];

            const host =
              document.getElementById(
                mapping.id
              );

            if (
              !html ||
              !host
            ) {
              return;
            }

            const parsed =
              new DOMParser()
                .parseFromString(
                  html,
                  'text/html'
                );

            const source =
              parsed.querySelector(
                mapping.selector
              )
              ||
              parsed.getElementById(
                mapping.id
              );

            const target =
              host.querySelector(
                mapping.selector
              )
              ||
              host;

            if (
              source &&
              target
            ) {
              target.innerHTML =
                source.innerHTML;
            }
          }
        );
      }

    }
  );
}